// Node Modules
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';

// Components
import Container from '@/components/global-components/Container';
import Question from './sub-components/Question';

// Themes
import theme from '@/themes/index';

const FaqBody = (
  {
    isDesktop,
    content: {
      title,
      subTitle,
      questions,
    } = {},
  } = {}
) => {
  return (
    <>
      <section className='questions-container'>
        <Container>
          <div className='header-container'>
            <h3>{title}</h3>
            <RichText render={subTitle} />
          </div>
          {questions.map(question => (
            <Question content={question} isDesktop={isDesktop} key={nanoid()}></Question>
          ))}
        </Container>
      </section>
      <style jsx>{`
        section.questions-container {
          padding: 3rem 2rem;
        }

        section.questions-container .header-container h3 {
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        section.questions-container .header-container h3 {
          color: ${theme.fontColors.optional4};
          font-family: ${theme.fontFamilies.montserratBold};
          margin-bottom: 3rem;
          line-height: 2rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.questions-container .header-container h3 {
            line-height: 3.5rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.questions-container {
            padding: 3rem 5rem;
          }

          section.questions-container .header-container h3 {
            margin-bottom: 4rem;
            line-height: 5.375rem;
          }
        }
      `}</style>
      <style global jsx>{`
        section.questions-container .header-container p {
          margin-bottom: 2rem;
          font-family: ${theme.fontFamilies.montserrat};
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.questions-container .header-container p {
          }
        }
      `}</style>
    </>
  );
};

export default FaqBody;
